import { useCallback } from 'react';
import { EVENT_TITLE_TRANSLATIONS, EventTitleEnum } from '../common/enums/common.enum';
import { useUiLanguage } from './useUiLanguage';

/**
 * The display name of a main event (Meals, Sleep...) in the interface language.
 *
 * Main events reach the admin as their English enum value. Their names already exist in
 * every language in EVENT_TITLE_TRANSLATIONS - the same names parents see in the app - so
 * this reads from there rather than keeping a second copy in the locale files that could
 * drift from what parents are shown. Anything not in the map is shown as it came.
 */
export const useEventTitle = (): ((title: string) => string) => {
  const language = useUiLanguage();
  return useCallback((title: string) => EVENT_TITLE_TRANSLATIONS[title as EventTitleEnum]?.[language] ?? title, [language]);
};
